<template>
  <div v-if="!item.hidden">
    <template
      v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path, onlyOneChild.query)">
        <el-menu-item :index="onlyOneChild.meta?.menuIndex || resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
          <menu-icon
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="onlyOneChild.meta.title"
          />
          <template #title><span class="menu-title" :title="hasTitle(translateRouteTitle(onlyOneChild))">{{
            translateRouteTitle(onlyOneChild) }}</span></template>
        </el-menu-item>
      </app-link>
    </template>

    <el-sub-menu v-else ref="subMenu" :index="resolvePath(item.path)" teleported>
      <template v-if="item.meta" #title>
        <menu-icon :icon="item.meta && item.meta.icon" :title="item.meta.title" />
        <span class="menu-title" :title="hasTitle(translateRouteTitle(item))">{{ translateRouteTitle(item) }}</span>
      </template>

      <sidebar-item v-for="(child, index) in item.children" :key="child.path + index" :is-nest="true" :item="child"
        :base-path="resolvePath(child.path)" class="nest-menu" />
    </el-sub-menu>
  </div>
</template>

<script setup>
import { isExternal } from '@/utils/validate'
import AppLink from './Link'
import MenuIcon from './MenuIcon.vue'
import { getNormalPath } from '@/utils/ruoyi'
import { translateRouteTitle } from '@/locales/route'

const props = defineProps({
  // route object
  item: {
    type: Object,
    required: true
  },
  isNest: {
    type: Boolean,
    default: false
  },
  basePath: {
    type: String,
    default: ''
  }
})

const onlyOneChild = ref({});

function hasOneShowingChild(children = [], parent) {
  if (!children) {
    children = [];
  }
  const showingChildren = children.filter(item => {
    if (item.hidden) {
      return false
    }
    onlyOneChild.value = item
    return true
  })

  // When there is only one child router, the child router is displayed by default
  if (showingChildren.length === 1) {
    return true
  }

  // Show parent if there are no child router to display
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: '', noShowingChildren: true }
    return true
  }

  return false
};

function resolvePath(routePath, routeQuery) {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(props.basePath)) {
    return props.basePath
  }
  const path = routePath.startsWith('/') ? routePath : getNormalPath(props.basePath + '/' + routePath)
  if (routeQuery) {
    let query = routeQuery;
    if (typeof query === 'string') {
      try { query = JSON.parse(query) } catch { query = undefined }
    }
    return { path, query }
  }
  return path
}

function hasTitle(title) {
  if (title && title.length > 5) {
    return title;
  } else {
    return "";
  }
}
</script>
